import { Verbiage } from '@infinitro/content';
import { bannerSet } from './data';
export const mapRacesToPromotions = (races, useDefaultId) => {
    return races.map((race) => ({
        id: useDefaultId ? 'flush-races' : race.raceId,
        title: Verbiage.weekly_races,
        startDate: race.startDate,
        endDate: race.endDate,
        description: Verbiage.weekly_races_description,
        buttonText: Verbiage.play_now,
        url: race?.raceId ? `/races/${race.raceId}` : '/promotion-page/race/flush-races/',
        isFlushRace: true,
        ...bannerSet('races')
    }));
};
